import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { registerServiceWorker } from "./lib/pwa";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root element bulunamadı");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: yüklenebilir webapp (yalnız prod build'de kaydolur)
registerServiceWorker();
